import { DatePicker, Input, Modal } from "antd";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import ToastHelper from "../../../../../helpers/ToastHelper";
import { unwrapResult } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";
import {
  requestGetListPet,
  requestUpdateHistoryVaccine,
} from "../../../../../redux/slices/adminSlice";

const ModalPetHistory = (props) => {
  const dispatch = useDispatch();
  const [isEdit, setIsEdit] = useState(false);
  const [arrVaccine, setArrVaccine] = useState([]);
  const { vaccineHistories, modalShow, setModalShow, currentPet } = props;

  const handleCancel = () => {
    setModalShow(false);
  };

  const handleEditHistory = async () => {
    const data = {
      id: currentPet?.id,
      vaccineHistories: arrVaccine,
    };
    const res = unwrapResult(await dispatch(requestUpdateHistoryVaccine(data)));
    const { error, message } = res;
    if (!error) {
      ToastHelper.showSuccess("Cập nhật thành công");
      dispatch(requestGetListPet({ page: 1, size: 20 }));
    } else {
      ToastHelper.showError(message);
    }
  };

  const changeIsEdit = () => {
    setIsEdit(!isEdit);
  };

  useEffect(() => {
    setArrVaccine(vaccineHistories);
  }, [vaccineHistories, modalShow]);

  const dayFormat = "D/M/YYYY";

  return (
    <div>
      <Modal
        width="800px"
        destroyOnClose
        open={modalShow}
        okText={"Cập nhật"}
        onOk={handleEditHistory}
        onCancel={handleCancel}
        title={<div className="text-2xl">Lịch sử tiêm chủng</div>}
        centered
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn className="del-btn" />
            <OkBtn />
          </>
        )}
      >
        <div className="flex flex-col space-y-2">
          {arrVaccine?.map((i, index) => {
            return (
              <div
                key={index}
                className="grid grid-cols-6 space-x-2 text-xl font-medium"
              >
                <DatePicker
                  format={dayFormat}
                  defaultValue={dayjs(i?.date, dayFormat)}
                  onChange={(date, dateString) =>
                    setArrVaccine([
                      ...arrVaccine.slice(0, index),
                      {
                        date: dateString,
                        vaccineName: i?.vaccineName,
                      },
                      ...arrVaccine.slice(index + 1),
                    ])
                  }
                  className="col-span-1"
                />
                <div className="col-span-5 flex flex-row space-x-2">
                  <Input
                    placeholder="Lịch sử tiêm chủng..."
                    value={i?.vaccineName}
                    onChange={(e) =>
                      setArrVaccine([
                        ...arrVaccine.slice(0, index),
                        {
                          date: i?.date,
                          vaccineName: e.target.value,
                        },
                        ...arrVaccine.slice(index + 1),
                      ])
                    }
                  />
                  <a
                    className="bg-red-400 text-white px-1 rounded-md hover:text-red-400 hover:bg-white border-red-400 border-[1px]"
                    onClick={() => {
                      setArrVaccine(
                        arrVaccine?.filter((_, arrIndex) => arrIndex != index)
                      );
                    }}
                  >
                    <DeleteOutlined />
                  </a>
                </div>

                {/* <span>{i?.date}:</span>
                  <span className="ml-2">{i?.vaccineName}</span> */}
              </div>
            );
          })}
          <a
            className="w-fit bg-green-400 text-white py-1 px-2 rounded-md hover:text-green-500 hover:bg-white border-green-500 border-[1px]"
            onClick={() => {
              setArrVaccine((prev) => [
                ...prev,
                { date: dayjs().format(dayFormat) },
              ]);
            }}
          >
            <PlusCircleOutlined className="mr-1" />
            Thêm lịch tiêm chủng
          </a>
        </div>
      </Modal>
    </div>
  );
};

export default ModalPetHistory;
